import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * FooterCopyright Component
 * Displays copyright text and a menu with links passed as props.
 */
const FooterCopyright = ({ pagesMenu }) => {
    const { t } = useTranslation();

    return (
        <div className="copyright">
            <div className="container">
                <div className="row">
                    {/* Left Section: Copyright Text */}
                    <div className="col-lg-6 col-md-6 align-self-center">
                        <div className="copy_text">
                            &copy; {t('footer.allRightsReserved')}
                        </div>
                    </div>
                    {/* Right Section: Menu Links */}
                    <div className="col-lg-6 col-md-6 align-self-center">
                        <div className="copyright_menus text-right">
                            <div className="language" />
                            <div className="copyright_menu inline">
                                <ul>
                                    {pagesMenu.map((item) => (
                                        <li key={item.id}>
                                            <Link to={item.link}>
                                                {t(item.nameKey)}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FooterCopyright;
